import { useCallback } from "react";
import { useSnackbarMutation } from "../../hooks";
import { MUTATIONS } from "../mutations";

export function useForceResetPassword(opts: { onSuccess?: () => void } = {}) {
  const { onSuccess } = opts;
  const [invokeForceResetPassword, { loading, error }] = useSnackbarMutation(
    MUTATIONS.FORCE_RESET_USER_PASSWORD,
    {
      onCompleted(data) {
        onSuccess?.();
      },
    }
  );

  const forceResetPassword = useCallback(
    (id: string) => {
      return invokeForceResetPassword({
        variables: {
          id,
        },
      });
    },
    [invokeForceResetPassword]
  );

  return {
    forceResetPassword,
    loading,
    error,
  };
}
